export const toCurrency = (value, opts = {}) =>
  window.Homebase?.toCurrency(value, opts);
